module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmb250YXdlc29tZS13ZWJmb250LnN2ZyI7"


//////////////////
// WEBPACK FOOTER
// node_modules/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 21
// module chunks = 0